import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router';
import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';
import back from '../assets/images/back_arrow.png';
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import Axios from 'axios';
import { useRecoilState } from 'recoil';
import { message } from 'antd'
import { patient_medical_data_loading } from '../Store/PatientProfileDetails'
import Picker from 'react-mobile-picker';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
const moment = require('moment');
const Editvitals = () => {
    const location = useLocation();
    const [readingValue, setReadingValue] = useState("");
    const [buttonHide, setButtonHide] = useState(false);
    const today = new Date();
    const numberOfDaysToAdd = 0;
    const date1 = today.setDate(today.getDate() + numberOfDaysToAdd);
    const defaultValue = new Date(date1).toISOString().split('T')[0] // yyyy-mm-dd
    const [date, setDate] = useState(defaultValue);
    var hour = today.getHours();
    var min = today.getMinutes();
    hour = (hour < 10 ? "0" : "") + hour;
    min = (min < 10 ? "0" : "") + min;
    var displayTime = hour + ":" + min;
    const [time, setTime] = useState(displayTime);
    const [vitalsOnSelectTrackingCode, setVitalsOnSelectTrackingCode] = useState("");
    const [tableData, setTableData] = useState([]);
    const [trackingId, setTrackingId] = useState('');
    const [minValue, setMinValue] = useState(0);
    const [maxValue, setMaxValue] = useState(0);
    const [minValues, setMinValues] = useState([]); // Array for min values
    const [maxValues, setMaxValues] = useState([]); // Array for max values
    const [trackingType, setTrackingType] = useState('');
    let pid = localStorage.getItem("patientid");
    const [medicalTrackingDataShow, setMedicalTrackingDataShow] = useRecoilState(patient_medical_data_loading);
    const [error, setError] = useState("");
    const [inputColor, setInputColor] = useState('');
    const token = localStorage.getItem('token');
    const headers = {
        Authorization: `Bearer ${token}`, // Add the token to the request headers
    };

    const backHandler = () => {
        global.OTPValidation = 'true';
        navigate(-1);
    }

    useEffect(() => {
        const getMedicalTrackingDataByTrackingid = async () => {
            if (location.state.orginalValue) {
                if (location.state.orginalValue != '') {
                    console.log(location.state);
                    setTrackingId(location.state.orginalValue.tracking_id);
                    setTrackingType(location.state.orginalValue.tracking_type);
                    try {
                        if (location.state.orginalValue.tracking_id == '3,6,8') {
                            // Check if min_value and max_value exist, and split by commas
                            const minValueArray = location?.state?.orginalValue?.min_value
                                ? location.state.orginalValue.min_value.split(",").map(Number)
                                : [];
                            const maxValueArray = location?.state?.orginalValue?.max_value
                                ? location.state.orginalValue.max_value.split(",").map(Number)
                                : [];
                            setMinValues(minValueArray);
                            setMaxValues(maxValueArray);
                            console.log("minValues:::", minValueArray, "maxValues:::", maxValueArray);
                            const response = await Axios.get(
                                `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientHealthTracking/get_blood_pressure_data_trackingid?trackingid=${location.state.orginalValue.tracking_id}&patientid=${pid}&MDT=PM&user_role=rp`,
                                { headers }
                            );
                            if (response.data.status == '1') {
                                console.log(response.data.data)
                                setTableData(response.data.data);
                            } else if (response.data.status == '401') {
                                console.error("Unauthorized access. Logging out.");
                                message.error(response.data?.message || 'Unauthorized');
                                logoutHandler();
                            }
                            else {
                                message.error('Unable to fetch data. Please try again later.');
                                setTableData([]);
                            }
                        } else {
                            setMinValue(Number(location?.state?.orginalValue?.min_value || 0));
                            setMaxValue(Number(location?.state?.orginalValue?.max_value || 0));
                            console.log("minValue:::", minValue, "maxValue:::", maxValue)
                            const response = await Axios.get(
                                `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientHealthTracking/get_medical_tracking_data_by_trackingid?trackingid=${location.state.orginalValue.tracking_id}&patientid=${pid}&MDT=PM&user_role=rp`,
                                { headers }
                            );
                            if (response.data.status == '1') {
                                console.log(response.data.data)
                                setTableData(response.data.data);
                            } else if (response.data.status == '401') {
                                console.error("Unauthorized access. Logging out.");
                                message.error(response.data?.message || 'Unauthorized');
                                logoutHandler();
                            }
                            else {
                                message.error('Unable to fetch data. Please try again later.');
                                setTableData([]);
                            }
                        }

                    } catch (error) {
                        // Display error message based on the response or fallback to a default message
                        if (error.response && error.response.status == '401') {
                            console.error("Unauthorized access. Logging out.");
                            message.error(error.response.data?.message || 'Unauthorized');
                            logoutHandler(); // Ensure logout happens here for unauthorized access
                        } else {
                            console.error("Error:", error.message);
                            message.error('Unable to fetch data. Please try again later.');
                        }

                    }
                }
            }
        }
        getMedicalTrackingDataByTrackingid();
    }, [location]);

    const logoutHandler = () => {
        localStorage.removeItem("phoneNo");
        localStorage.removeItem("patientid");
        localStorage.removeItem("patientLocalImage");
        localStorage.removeItem("patientLocalData");
        localStorage.removeItem("patientUniqueId");
        localStorage.removeItem("chronic_illness_data");
        localStorage.removeItem("allergic_information_data");
        localStorage.removeItem("family_relation_data");
        localStorage.removeItem("family_disease_data");
        localStorage.removeItem("token");

        navigate("/Login");

    }

    const navigate = useNavigate();

    const onReadingValueUpdate = (event) => {
        const value = Number(event.target.value); // Convert to a number

        if (isNaN(value) || value <= 0) {
            setError("Reading value cannot be zero or empty");
            setInputColor('red');
            setButtonHide(true);
        } else if (value < minValue) {
            setError(`Value is below the minimum (${minValue})`);
            setButtonHide(false);
            setInputColor('red');
        } else if (value > maxValue) {
            setError(`Value exceeds the maximum (${maxValue})`);
            setButtonHide(false);
            setInputColor('orange');
        } else {
            setError(""); // Clear any errors
            setInputColor('green');
            setButtonHide(false);
        }

        setReadingValue(value); // Update the reading value
    }

    const handleChangeDate = (event) => {
        setDate(event.target.value);
    }

    const handleChangeTime = (event) => {
        setTime(event.target.value);
    }

    const updateHandler = (e) => {
        setButtonHide(true);
        e.preventDefault();
        if (readingValue > 0 || trackingId == '3,6,8') {
            let id = localStorage.getItem("patientid");
            console.log(id);
            if (trackingId == '3,6,8') {
                const trackingData = [
                    { tracking_id_fk: 3, value: parseInt(pickerValue.systolic, 10) || "--" }, // Systolic value
                    { tracking_id_fk: 6, value: parseInt(pickerValue.diastolic, 10) || "--" }, // Diastolic value
                    { tracking_id_fk: 8, value: parseInt(pickerValue.pulse, 10) || "--" }, // Pulse value
                ];
                let PM = 'PM';
                let rp = 'rp';
                console.log("trackingData:::", trackingData)
                const requestBody = {
                    patients_id_fk: parseInt(pid), // Patient ID
                    tracking_datetime: date + " " + time, // Current date and time
                    tracking_data: trackingData, // Tracking data as array
                    MDT: PM,
                    user_role: rp,
                };
                $.ajax({
                    type: "POST",
                    url: `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientHealthTracking/add_blood_pressure`,
                    data: JSON.stringify(requestBody),
                    contentType: "application/json", // Ensure JSON content type
                    headers: headers,
                    success: function (response) {
                        console.log("Data updated successfully", response);
                        try {
                            const getMedicalTrackingData = async () => {
                                const response = await Axios.get(
                                    `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientHealthTracking/get_blood_pressure_data_trackingid?trackingid=${trackingId}&patientid=${pid}&MDT=PM&user_role=rp`,
                                    { headers }
                                );
                                if (response.data.status == '1') {
                                    console.log(response.data);
                                    setTableData(response.data.data);
                                    setMedicalTrackingDataShow(true);
                                } else if (response.data.status == '401') {
                                    console.error("Unauthorized access. Logging out.");
                                    message.error(response.data?.message || 'Unauthorized');
                                    logoutHandler();
                                } else {
                                    message.error('Unable to fetch data. Please try again later.');
                                }
                                setReadingValue('');
                            };
                            getMedicalTrackingData();
                            setButtonHide(false);
                        } catch (error) {
                            if (error.response && error.response.status == '401') {
                                console.error("Unauthorized access. Logging out.");
                                message.error(error.response.data?.message || 'Unauthorized');
                                logoutHandler();
                            } else {
                                console.error("Error:", error.message);
                                message.error('Unable to fetch data. Please try again later.');
                            }
                            setButtonHide(false);
                        }
                    },
                    error: function (err) {
                        if (err.status == '401') {
                            console.error("Unauthorized access. Logging out.");
                            message.error(err.response.data?.message || 'Unauthorized');
                            logoutHandler();
                        } else {
                            console.error('Error occurred:', err.responseText);
                            message.error('Data upload failed. Please try again later.');
                        }
                        setButtonHide(false);
                    }
                });
            } else {
                let formdata = $(e.target);
                formdata = new FormData();
                formdata.append('patients_id_fk', pid);
                formdata.append('tracking_id_fk', trackingId);
                //formdata.append('tracking_code_fk', vitalsOnSelectTrackingCode);
                formdata.append('value', readingValue);
                formdata.append('tracking_datetime', date + " " + time);
                formdata.append('MDT', 'PM');
                formdata.append('user_role', 'rp');
                console.log(date + " " + time)
                //formdata.append('time', time);
                console.log("vital details : ", trackingId, vitalsOnSelectTrackingCode)
                $.ajax({
                    type: "POST",
                    url: `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientHealthTracking/add_medical_tracking_data`,
                    data: formdata,
                    processData: false,
                    contentType: false,
                    headers: headers,
                    success(data) {
                        console.log("updated successfully", data);
                        try {
                            const getMedicalTrackingData = async () => {
                                const response = await Axios.get(
                                    `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientHealthTracking/get_medical_tracking_data_by_trackingid?trackingid=${trackingId}&patientid=${pid}&MDT=PM&user_role=rp`,
                                    { headers }
                                );
                                if (response.data.status == '1') {
                                    console.log(response.data)
                                    setTableData(response.data.data)
                                    setMedicalTrackingDataShow(true);
                                } else if (response.data.status == '401') {
                                    console.error("Unauthorized access. Logging out.");
                                    message.error(error.response.data?.message || 'Unauthorized');
                                    logoutHandler();
                                } else {
                                    message.error('Unable to fetch data. Please try again later.');
                                }
                                setReadingValue('')
                            }
                            getMedicalTrackingData();
                            setButtonHide(false);
                        } catch (error) {
                            // Display error message based on the response or fallback to a default message
                            if (error.response && error.response.status == '401') {
                                console.error("Unauthorized access. Logging out.");
                                message.error(error.response.data?.message || 'Unauthorized');
                                logoutHandler(); // Ensure logout happens here for unauthorized access
                            } else {
                                console.error("Error:", error.message);
                                message.error('Unable to fetch data. Please try again later.');
                            }
                            setButtonHide(false);
                        }
                    },
                    error: function (err) {
                        if (err.status == '401') {
                            // Token expired, show message and log out
                            message.error(err.responseJSON.message || 'Unauthorized');
                            logoutHandler();
                        } else {
                            console.error('Error occurred:', err.responseText);
                            message.error('Data upload failed. Please try again later.');
                        }
                        setButtonHide(false);
                    }
                });
            }
        } else {
            setError("Reading value cannot be zero or Empty");
        }
    }

    //Take Blood pressure 
    const numberRange = (start, end) =>
        Array.from({ length: end - start + 1 }, (_, i) => {
            // Format numbers to have 3 digits, adding leading zeros if necessary
            return (start + i).toString().padStart(3, "0");
        });

    // Set up your selections to store values as strings from 000 to 200
    const selections = {
        systolic: numberRange(1, 200),
        diastolic: numberRange(1, 200),
        pulse: numberRange(1, 200),
    };

    const [pickerValue, setPickerValue] = useState({
        systolic: '120',
        diastolic: '080',
        pulse: '075',
    });

    const [showMore, setShowMore] = useState(false);
    const [showMoreGraph, setShowMoreGraph] = useState(false);

    const toggleShowMore = () => {
        setShowMore((prevState) => !prevState);
    };

    const toggleShowMoreGraph = () => {
        setShowMoreGraph((prevState) => !prevState);
    };

    const [errorMessage, setErrorMessage] = useState("");

    // Check if values are out of range
    const isValueOutOfRangeSystolic = minValues[0] > pickerValue.systolic || maxValues[0] < pickerValue.systolic;
    const isValueOutOfRangeDiastolic = minValues[1] > pickerValue.diastolic || maxValues[1] < pickerValue.diastolic;
    const isValueOutOfRangePulse = minValues[2] > pickerValue.pulse || maxValues[2] < pickerValue.pulse;

    // All values normal check
    const allValueNormal = !isValueOutOfRangeSystolic && !isValueOutOfRangeDiastolic && !isValueOutOfRangePulse;

    const getValueColor = (value, min, max) => {
        if (value < min) {
            return 'red';  // Value below min
        } else if (value > max) {
            return 'orange';  // Value above max
        } else {
            return 'green';  // Value within range
        }
    };

    const systolicColor = getValueColor(pickerValue.systolic, minValues[0], maxValues[0]);
    const diastolicColor = getValueColor(pickerValue.diastolic, minValues[1], maxValues[1]);
    const pulseColor = getValueColor(pickerValue.pulse, minValues[2], maxValues[2]);

    useEffect(() => {
        let message = '';

        // Add/remove message for systolic, diastolic, and pulse based on their current values
        if (isValueOutOfRangeSystolic) {
            message += "Systolic value is out of range. ";
        } else {
            // Remove systolic from the message if it's no longer out of range
            message = message.replace("Systolic value is out of range. ", "");
        }

        if (isValueOutOfRangeDiastolic) {
            message += "Diastolic value is out of range. ";
        } else {
            // Remove diastolic from the message if it's no longer out of range
            message = message.replace("Diastolic value is out of range. ", "");
        }

        if (isValueOutOfRangePulse) {
            message += "Pulse value is out of range. ";
        } else {
            // Remove pulse from the message if it's no longer out of range
            message = message.replace("Pulse value is out of range. ", "");
        }

        // If there are any errors, append the general message
        if (isValueOutOfRangeSystolic && isValueOutOfRangeDiastolic && isValueOutOfRangePulse) {
            message = "Highlighted readings indicate values outside the normal range. Please review them. "
        }

        // Set the error message
        setErrorMessage(message);
    }, [isValueOutOfRangeSystolic, isValueOutOfRangeDiastolic, isValueOutOfRangePulse]); // Dependency array to track the values


    return (
        <div>
            <header className="header">
                <img src={back} style={{ height: 20, width: 20 }} alt="back button" onClick={backHandler} />
                <h1 className="header-title"> Add Medical Tracking</h1>
            </header>
            <>
                <div className="first-div">
                    <div>
                        <span
                            style={{
                                cursor: 'pointer',
                                color: '#007BFF',
                                textDecoration: 'underline',
                                fontSize: 12,
                            }}
                            onClick={toggleShowMore}
                        >
                            {showMore ? 'Show Less' : 'Show More'}
                        </span>
                    </div>
                    {showMore && (
                        <div
                            className="first-div"
                            style={{
                                marginTop: 5,
                                maxHeight: 200,
                                overflowY: 'scroll',
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}
                        >
                            <div style={{ marginTop: 5 }} className="medicineview">
                                <table
                                    id="prescriptiondata"
                                    style={{
                                        width: '100%',
                                        paddingRight: 5,
                                        borderRadius: 5,
                                        marginLeft: 5,
                                        marginRight: 5,
                                    }}
                                >
                                    <thead>
                                        <tr>
                                            <th style={{ width: '50%', textAlign: 'center' }}>Reading</th>
                                            <th style={{ width: '50%', textAlign: 'center' }}>Date and Time</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tableData.length > 0 ? (
                                            tableData.map((val, index) => (
                                                <tr key={index}>
                                                    <td className="value" style={{ textAlign: 'center' }}>{val.value}</td>
                                                    <td className="value" style={{ textAlign: 'center' }}>
                                                        {moment(val.tracking_datetime).format('DD.MM.YYYY  HH:mm')}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan={2}
                                                    className="label_style"
                                                    style={{
                                                        textAlign: 'center',
                                                        color: 'red',
                                                    }}
                                                >
                                                    No data found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>

                {tableData && tableData.length > 0 && (
                    <div className="first-div">
                        <div>
                            <span
                                style={{
                                    cursor: 'pointer',
                                    color: '#007BFF',
                                    textDecoration: 'underline',
                                    fontSize: 12
                                }}
                                onClick={toggleShowMoreGraph}
                            >
                                {showMoreGraph ? 'Show Less' : 'Show More'}
                            </span>
                        </div>
                        {showMoreGraph && (
                            <div
                                className="first-div"
                                style={{
                                    marginTop: 5,
                                    maxHeight: 320, // Adjust height based on your layout
                                    overflowY: 'scroll',
                                    scrollbarWidth: 'none',
                                    msOverflowStyle: 'none',
                                }}
                            >
                                {trackingId !== '3,6,8' ? (
                                    <div className="centered-chart">
                                        <LineChart
                                            width={310}
                                            height={300}
                                            data={tableData}
                                            margin={{
                                                top: 5,
                                                left: -30,
                                                bottom: 5,
                                            }}
                                        >
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="create_date" />
                                            <YAxis />
                                            <Tooltip />
                                            <Legend />
                                            <Line
                                                type="monotone"
                                                dataKey="Reading"
                                                stroke="#8884d8"
                                                activeDot={{ r: 8 }}
                                            />
                                        </LineChart>
                                    </div>
                                ) : (
                                    <div className="centered-chart">
                                        <LineChart
                                            width={310}
                                            height={300}
                                            data={tableData}
                                            margin={{
                                                top: 5,
                                                left: -30,
                                                bottom: 5,
                                            }}
                                        >
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="create_date" />
                                            <YAxis />
                                            <Tooltip />
                                            <Legend />
                                            <Line
                                                type="monotone"
                                                dataKey="systolic_value"
                                                stroke="#8884d8"
                                                activeDot={{ r: 8 }}
                                            />
                                            <Line
                                                type="monotone"
                                                dataKey="diastolic_value"
                                                stroke="#82ca9d"
                                            />
                                            <Line
                                                type="monotone"
                                                dataKey="pulse_rate_value"
                                                stroke="#ffc658"
                                            />
                                        </LineChart>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )}

                <div className='first-div' style={{ marginTop: 20, marginBottom: 40 }}>
                    <div style={{ display: 'flex', flexDirection: 'row', padding: '0 20px' }}>
                        <p className="label_style" style={{ textAlign: 'left', fontSize: 12 }}>Add data for </p>
                        <p className="label_style" style={{ color: 'black', fontSize: 12 }}>{trackingType} </p>
                    </div>
                    {trackingId == '3,6,8' ? (
                        <>
                            <div
                                style={{
                                    width: "100%",
                                    maxWidth: "400px",
                                    height: "280px", // Increased height to accommodate headers
                                    marginBottom: "20px",
                                    display: "flex",
                                    flexDirection: "column", // Stack headers and pickers
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        width: "100%",
                                        maxWidth: "400px", // Space between headers and pickers
                                    }}
                                >
                                    {/* Headers for the pickers */}
                                    <div style={{
                                        width: "25%", textAlign: "center", fontWeight: "bold", fontSize: "18px"
                                    }}>
                                        Systolic
                                    </div>
                                    <div style={{
                                        width: "25%", textAlign: "center", fontWeight: "bold", fontSize: "18px"
                                    }}>
                                        Diastolic
                                    </div>
                                    <div style={{
                                        width: "25%", textAlign: "center", fontWeight: "bold", fontSize: "18px"
                                    }}>
                                        Pulse
                                    </div>
                                </div>
                                <Picker value={pickerValue} onChange={setPickerValue}>
                                    {Object.keys(selections).map((name) => (
                                        <Picker.Column key={name} name={name} style={{ margin: "0 20px" }}>
                                            {selections[name].map((option, index) => {
                                                const selectedIndex = selections[name].indexOf(pickerValue[name]);
                                                let color = "black";

                                                // Determine color based on value's range
                                                if (name === 'systolic') {
                                                    color = getValueColor(option, minValues[0], maxValues[0]);
                                                } else if (name === 'diastolic') {
                                                    color = getValueColor(option, minValues[1], maxValues[1]);
                                                } else if (name === 'pulse') {
                                                    color = getValueColor(option, minValues[2], maxValues[2]);
                                                }

                                                return (
                                                    <Picker.Item
                                                        key={option}
                                                        value={option}
                                                        style={{
                                                            fontSize: "28px",
                                                            fontWeight: "bold",
                                                            color: color, // Apply dynamic color
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        {option}
                                                    </Picker.Item>
                                                );
                                            })}
                                        </Picker.Column>
                                    ))}
                                </Picker>
                                <div
                                    style={{
                                        fontSize: "18px",
                                        fontWeight: "bold",
                                        textAlign: "center",
                                    }}
                                >
                                    BP: <span style={{ color: systolicColor }}>{pickerValue.systolic || "--"} BPHG</span>,{" "}
                                    <span style={{ color: diastolicColor }}>{pickerValue.diastolic || "--"} BPMM</span>,{" "}
                                    <span style={{ color: pulseColor }}>{pickerValue.pulse || "--"} BPM</span>
                                </div>
                            </div>
                        </>) :
                        (<>
                            <div style={{ padding: '0 20px', marginTop: 10 }} className="flex-div">
                                <div style={{ textAlign: 'left' }}>
                                    <p className="label_style" style={{ fontSize: 12 }}> Reading Value:</p>
                                </div>
                                <div style={{ marginLeft: 15 }}>
                                    <input
                                        className="input_style"
                                        style={{
                                            fontSize: 12,
                                            padding: '8px 12px',
                                            borderRadius: 4,
                                            width: 160,
                                            marginLeft: 10,
                                            color: inputColor,
                                        }}
                                        type="tel"
                                        name="name"
                                        required
                                        value={readingValue}
                                        maxLength={3}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d*$/.test(value)) { // Regex to check for numbers only
                                                onReadingValueUpdate(e);
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </>)}
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0 20px' }}>
                        {/* Date Input Section */}
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <label className="label_style" style={{ fontSize: 12, marginBottom: 5 }}>Date:</label>
                            <input
                                className="input_style"
                                type="date"
                                name="date"
                                value={date}
                                style={{
                                    fontSize: 12,
                                    padding: '8px 12px',
                                    borderRadius: 4,
                                    width: 140,
                                    marginTop: 5,
                                    marginLeft: 10
                                }}
                                onChange={(event) => handleChangeDate(event)}
                            />
                        </div>

                        {/* Time Input Section */}
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <label className="label_style" style={{ fontSize: 12, marginBottom: 5 }}>Time:</label>
                            <input
                                className="input_style"
                                type="time"
                                name="time"
                                value={time}
                                style={{
                                    fontSize: 12,
                                    padding: '8px 12px',
                                    borderRadius: 4,
                                    width: 140,
                                    marginTop: 5,
                                    marginLeft: 10
                                }}
                                onChange={(event) => handleChangeTime(event)}
                            />
                        </div>
                    </div>

                    {buttonHide === false ? (
                        <button
                            onClick={(event) => updateHandler(event)}
                            type="submit"
                            style={{ marginTop: 30, width: 120 }}
                            className="btn btn-auto btn-primary"
                        >
                            Add
                        </button>
                    ) : (
                        setError.length > 0 ? (
                            <></>
                        ) : (
                            <p
                                style={{
                                    fontSize: 12,
                                    color: 'green',
                                    fontWeight: 'bold',
                                    marginTop: 15
                                }}
                            >
                                Updating...
                            </p>
                        )
                    )}
                    {(error || !allValueNormal) && (
                        <p style={{ color: 'red', fontSize: '12px', padding: 10 }}>{errorMessage}</p>
                    )}
                </div>
            </>
        </div>
    )
}

export default Editvitals
